import { MaterialUnit } from "fe-shared/src/types/domain";
import { RetreadingTransactionFormContent } from "../types";

const getMonth = (monthStr: string) => new Date(`${monthStr}-1-01`).getMonth();

export const retreadingTransactionFormValuesApiMapper = (
  values: RetreadingTransactionFormContent,
  isEdit: boolean = false
) => {
  const {
    collectionInfoMaterials,
    retreadRepairInfoMaterials,
    recoveryInfoMaterials,
    companyName,
    periodYear,
    periodMonth,
    isKnownRetreaderTiresActualWeight,
    companyId,
    ...rest
  } = values;

  const mapMaterials = (
    materials: Record<string, number | undefined>,
    unit: MaterialUnit
  ) =>
    Object.entries(materials).map(([materialCode, unitQuantity]) => ({
      materialCode,
      units: {
        unitQuantity: unitQuantity as number,
        unit,
      },
    }));

  return {
    retreadingPeriodDate: new Date(
      Date.UTC(periodYear, getMonth(periodMonth))
    ).toISOString(),
    collectionInfoMaterials: mapMaterials(
      collectionInfoMaterials,
      isKnownRetreaderTiresActualWeight ? MaterialUnit.Kg : MaterialUnit.Units
    ),
    retreadRepairInfoMaterials: mapMaterials(
      retreadRepairInfoMaterials,
      MaterialUnit.Kg
    ),
    recoveryInfoMaterials: mapMaterials(recoveryInfoMaterials, MaterialUnit.Kg),
    isKnownRetreaderTiresActualWeight,
    ...rest,
    ...(isEdit ? {} : { companyId }),
  };
};

export default {
  retreadingTransactionFormValuesApiMapper,
};
